// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"cQ-z","inlineTitle":"dQ-z","sponsoredAdsWrapper":"eQ-z","marketplaceRecosWrapper":"fQ-z"};